import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Tag as AntTag, Button, Modal, Form, Input, Space, Popconfirm } from 'antd';

import { tagIndexRequest, tagCreateRequest, tagUpdateRequest, tagDeleteRequest } from '~/store/modules/tag/actions';

import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Container } from './styles';

export default function Tags() {
  const dispatch = useDispatch();

  const list = useSelector(store => store.tag.list);
  const loading = useSelector(store => store.tag.loading);
  const saving = useSelector(store => store.tag.saving);

  const [isVisible, setIsVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [color, setColor] = useState('#1677ff');

  const [form] = Form.useForm();

  useEffect(() => {
    window.scroll({ top: 0, behavior: 'smooth' });

    dispatch(tagIndexRequest());
  }, []);

  function onOpen(tag) {
    setEditing(tag || null);
    setColor(tag ? tag.color : '#1677ff');
    form.setFieldsValue({ name: tag ? tag.name : '' });
    setIsVisible(true);
  }

  function onFinish(values) {
    const data = { name: values.name, color };

    if (editing) dispatch(tagUpdateRequest(editing.id, data, () => setIsVisible(false)));
    else dispatch(tagCreateRequest(data, () => setIsVisible(false)));
  }

  const columns = [
    {
      title: 'Tag',
      dataIndex: 'name',
      key: 'tag',
      render: (name, tag) => <AntTag color={tag.color}>{name}</AntTag>,
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Cor',
      dataIndex: 'color',
      key: 'color',
      width: 120,
    },
    {
      title: '',
      key: 'actions',
      width: 120,
      align: 'right',
      render: (_, tag) => (
        <Space>
          <Button type="text" icon={<EditOutlined />} onClick={() => onOpen(tag)} />
          <Popconfirm
            title="Excluir esta tag? Ela será removida de todas as tarefas."
            okText="Excluir"
            cancelText="Cancelar"
            onConfirm={() => dispatch(tagDeleteRequest(tag.id))}
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Container>
      <div className="tags-header">
        <h2>Tags</h2>

        <Button type="primary" icon={<PlusOutlined />} onClick={() => onOpen()}>Nova tag</Button>
      </div>

      <Table
        rowKey="id"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={list}
        pagination={false}
      />

      <Modal
        title={editing ? 'Editar tag' : 'Nova tag'}
        visible={isVisible}
        onCancel={() => setIsVisible(false)}
        onOk={() => form.submit()}
        okText="Salvar"
        cancelText="Cancelar"
        confirmLoading={saving}
        destroyOnClose
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            label="Nome"
            name="name"
            rules={[{ required: true, message: 'Nome é obrigatório' }]}
          >
            <Input maxLength={50} />
          </Form.Item>

          <Form.Item label="Cor">
            <Space>
              <input
                type="color"
                value={color}
                onChange={ev => setColor(ev.target.value)}
                style={{ width: 40, height: 32, padding: 0, border: 'none', background: 'none', cursor: 'pointer' }}
              />
              <AntTag color={color}>Pré-visualização</AntTag>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Container>
  );
}
